import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function Audience() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-teal-50 p-8 rounded-xl border border-teal-100" data-id="element-4">
            <h3 className="font-serif text-2xl text-teal-900 mb-6 flex items-center" data-id="element-5">
              <span className="bg-teal-900 text-white rounded-full p-1 mr-3" data-id="element-6">
                <Check size={16} data-id="element-7" />
              </span>
              This IS for you if:
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {["You're 35+ and feel newly stuck", 'Your belly weight appeared "out of nowhere"', 'You want a calm, realistic plan', "You're tired of starting over"].map((item, i) => <li key={i} className="flex items-start text-charcoal-800" data-id="element-9">
                  <Check className="w-5 h-5 text-teal-700 mr-3 mt-0.5 flex-shrink-0" data-id="element-10" />
                  <span data-id="element-11">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-rose-50 p-8 rounded-xl border border-rose-100" data-id="element-12">
            <h3 className="font-serif text-2xl text-charcoal-900 mb-6 flex items-center" data-id="element-13">
              <span className="bg-rose-400 text-white rounded-full p-1 mr-3" data-id="element-14">
                <X size={16} data-id="element-15" />
              </span>
              This is NOT for you if:
            </h3>
            <ul className="space-y-4" data-id="element-16">
              {['You want extreme promises or rapid results claims', 'You need medical treatment or individualized hormone/thyroid care', "You're looking for a punishing workout program"].map((item, i) => <li key={i} className="flex items-start text-charcoal-800" data-id="element-17">
                  <X className="w-5 h-5 text-rose-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-18" />
                  <span data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-12 text-center" data-id="element-20">
          <p className="font-serif text-xl md:text-2xl text-teal-900 italic" data-id="element-21">
            This is a gentle reset — not a crash program.
          </p>
        </motion.div>
      </div>
    </section>;
}